<template>
  <a-row class="relation-list">
    <span v-for="(item, index) in items" :key="index">
      <a v-if="index == (items.length - 1)" style="padding: 0px 0px 0px 0px; color: #1890ff;" @click="changelist($event, index)">
        {{item.name}}&nbsp;<a-icon :component="CorrelateIcon"  :style="styleCI"/> 
        <!-- span> &varpropto; </span -->
      </a>
      <a v-else="" style="padding: 0px 4px 0px 0px;" @click="changelist($event, index)">
        {{item.name}}
        <a-icon :component="CorrelateIcon"  :style="styleCI"/>
        <!-- span> &varpropto; </span -->
      </a>
    </span>
  </a-row>
</template>

<script>

import CorrelateIcon from '@/assets/img/correlate.vue'

export default {
  name: 'RelationList',
  props: {
    list: Array,
    default: []
  },
  data() {
    return {
      CorrelateIcon,
      styleCI: "height:16px; width:16px;",
      items: this.list
    }
  },
  watch: {
    list: function(newvalue, oldvalue) {
      let roots = document.getElementsByClassName("relation-list");
      let root = roots[0];
      this.list = newvalue;
      this.items = newvalue;
      for(let i = 0; i < root.childNodes.length; i++) {
        let line = root.childNodes[i].firstChild
        if (i == (this.items.length - 1)) {
          line.style.color = "#1890ff"
        } else {
          line.style.color = "gray"
        }
      }
    }
  },
  methods: {
    changelist: function(e, key) {
      let target;
      if (e.target.style.padding == "") {
        target = e.target.parentNode.parentNode.parentNode
      } else {
        target = e.target.parentNode.parentNode
      }
      for(let i = 0; i < target.childNodes.length; i++) {
        let line = target.childNodes[i].firstChild
        if (i == key) {
          line.style.color = "#1890ff"
        } else {
          line.style.color = "gray"
        }
      }
      this.$emit('changelist', key);
    }
  },
  created() {
  }
}
</script>

<style scoped>
  .relation-list {
    text-align: left; 
    padding: 8px; 
    border-bottom: 1px solid #d1d5da;
    background-color: #f5f6f5; /*#f1f8ff;*/
  }
</style>
